import {
  Box,
  Container,
  Flex,
  Link,
  SimpleGrid,
  Stack,
} from '@chakra-ui/react';
import { Card, Divider, Text } from '@diamond/shared/ui';
import NextImage from 'next/image';
import NextLink from 'next/link';

interface SolBuyerAuthenticationLayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  withActionLink?: {
    label: string;
    href: string;
  };
}

export function SolBuyerAuthenticationLayout({
  children,
  pageTitle,
  withActionLink,
}: SolBuyerAuthenticationLayoutProps) {
  return (
    <Box>
      <Container
        as={SimpleGrid}
        maxW="6xl"
        columns={{ base: 1, md: 2 }}
        spacing={{ base: 10, lg: 32 }}
        pt={{ base: 6, md: 'unset' }}
        pb={{ base: 10, md: 'unset' }}
        sx={{
          minHeight: '100vh',
          '@supports (min-height: 100dvh)': {
            minHeight: '100dvh',
          },
        }}
      >
        <Flex align={{ base: 'unset', md: 'center' }} justify="center">
          <Card flex="1">
            <Stack>
              <Box w={{ base: '136px', md: '232px' }} flexShrink={0}>
                <NextImage
                  src="/images/sukanda_logo_LR.png"
                  alt="Sukanda OneLink"
                  priority
                  width={232}
                  height={49}
                  sizes="(max-width: 767px) 136px, 232px"
                  style={{ width: '100%', height: 'auto' }}
                />
              </Box>
              <Box py="2">
                <Text as="h1" fontSize="xl" fontWeight="bold">
                  {pageTitle}
                </Text>
                <Stack direction="row" alignItems="flex-end">
                  {withActionLink?.href === '/aktivasi' ? (
                    <Text fontSize={{ base: 'xs', md: 'md' }}>
                      Belum punya akun Sukanda OneLink?
                    </Text>
                  ) : (
                    <Text fontSize={{ base: 'xs', md: 'md' }}>
                      Sudah punya akun Sukanda OneLink?
                    </Text>
                  )}
                  {withActionLink && (
                    <NextLink
                      href={withActionLink.href}
                      legacyBehavior
                      passHref
                    >
                      <Link
                        color="blue"
                        fontWeight="semibold"
                        fontSize={{ base: 'sm', md: 'md' }}
                      >
                        {withActionLink.label}
                      </Link>
                    </NextLink>
                  )}
                </Stack>
                <Divider pt="2" />
              </Box>
              {children}
            </Stack>
          </Card>
        </Flex>
        <Flex
          flex={1}
          align="center"
          justify="center"
          display={{ base: 'none', md: 'flex' }}
        >
          <Card rounded="3xl" m="unset">
            <NextImage
              src="/images/login.png"
              alt="SUKANDA ONELINK"
              priority
              width={527}
              height={750}
              sizes="(max-width: 768px) 0px, 527px"
              style={{ objectFit: 'cover' }}
            />
          </Card>
        </Flex>
      </Container>
    </Box>
  );
}
